import type { IconSvgObject } from './types';

const BookSearchIcon: IconSvgObject = [
  ["path", { d: "M17 22H5C3.89543 22 3 21.1046 3 20M19 9V2H5C3.89543 2 3 2.89543 3 4V20M3 20C3 18.8954 3.89543 18 5 18H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 17.5L21 20M19 15C19 16.6569 17.6569 18 16 18C14.3431 18 13 16.6569 13 15C13 13.3431 14.3431 12 16 12C17.6569 12 19 13.3431 19 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookSearchIcon;
